import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { CommonLabelAndValueList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';

const JointNomineesSectionImpl: React.FC = () => {
  const {
    reviewAndSubmitNominationPageUiStore,
  } = useStores();
  
  return (
    <FlexBox
      wrap
      isFullWidth
      as='section'
      className='nomination-section'
    >
      <Text
        as='h3'
        block
        weight='semibold'
        size={400}
      >
        Joint nominee
      </Text>
      {
        reviewAndSubmitNominationPageUiStore.currentNomination?.jointNominees.map((jointNominee, index) => (
          <FlexBox
            key={jointNominee.organizationId}
            isFullWidth
            direction='column'
            className='nomination-section__list'
          >
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label={`Nominee #${index + 1} - Partner ID:`}
                childrenFallback={jointNominee.mpnId}
              />
              <CommonLabelAndValueList
                label='Company:'
                childrenFallback={jointNominee.companyName}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Address 1:'
                childrenFallback={jointNominee.address1}
              />
              <CommonLabelAndValueList
                label='Address 2:'
                childrenFallback={jointNominee.address2}
              />
            </FlexBox>
            <FlexBox 
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='City:'
                childrenFallback={jointNominee.city}
              />
              <CommonLabelAndValueList
                label='State:'
                childrenFallback={jointNominee.stateProvince}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Postal code:'
                childrenFallback={jointNominee.postalCode}
              />
              <CommonLabelAndValueList
                label='Country:'
                childrenFallback={jointNominee.country.displayName}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Company phone number:'
                childrenFallback={jointNominee.phoneNumber}
              />
              <CommonLabelAndValueList
                label='Website URL:'
                childrenFallback={jointNominee.websiteUrl}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Prefix:'
                childrenFallback={jointNominee.prefix}
              />
              <CommonLabelAndValueList
                label='First name:'
                childrenFallback={jointNominee.firstName}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Last name:'
                childrenFallback={jointNominee.lastName}
              />
              <CommonLabelAndValueList
                label='Contact email:'
                childrenFallback={jointNominee.emailAddress}
              />
            </FlexBox>
          </FlexBox>
        ))
      }
    </FlexBox>
  );
}

export const JointNomineesSection = observer(JointNomineesSectionImpl);
